import axios from "axios";
import { useCallback } from "react";
import { useAuth } from "@clerk/react";
import { useQuery } from "@tanstack/react-query";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const SITE = {
  domain: "inlashippinghub.delivery",
  email: "Inlashippinghubdelivery@gmail.com",
  phone: "1 954-375-7658",
  tel: "tel:+19543757658",
  whatsapp: "https://wa.me/19543757658",
};

export const errMsg = (e) => e?.response?.data?.detail?.toString?.() || e?.message || "Something went wrong";

export const ADMIN_TOKEN_KEY = "inla_admin_token";

export function useApi() {
  const { getToken, isSignedIn } = useAuth();
  return useCallback(async (method, url, data) => {
    const token = isSignedIn ? await getToken() : null;
    const adminToken = localStorage.getItem(ADMIN_TOKEN_KEY);
    const headers = {};
    if (token) headers.Authorization = `Bearer ${token}`;
    if (adminToken) headers["X-Admin-Token"] = adminToken;
    const r = await axios({ method, url: API + url, data, headers });
    return r.data;
  }, [getToken, isSignedIn]);
}

export function useAdminSession() {
  const api = useApi();
  const { isLoaded, userId } = useAuth();
  return useQuery({ queryKey: ["admin-session", userId], queryFn: () => api("get", "/admin/session"), enabled: isLoaded, retry: false, staleTime: 0 });
}

export function useMe() {
  const { isSignedIn, userId } = useAuth();
  const api = useApi();
  return useQuery({ queryKey: ["me", userId], queryFn: () => api("get", "/me"), enabled: !!isSignedIn });
}

export function useMeta() {
  return useQuery({ queryKey: ["meta"], queryFn: async () => (await axios.get(`${API}/meta`)).data, staleTime: Infinity });
}

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" }) : "-");
export const fmtUSD = (v) => `$${Number(v || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const fmtDay = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { dateStyle: "medium" }) : "-");
